import React from 'react';
import Icon from '../../../components/AppIcon';

const PerformanceChart = ({ platformFilter }) => {
  const chartData = [
    { day: 'Mon', posts: 3, engagement: 65, impressions: 12500 },
    { day: 'Tue', posts: 5, engagement: 82, impressions: 18200 },
    { day: 'Wed', posts: 4, engagement: 78, impressions: 15800 },
    { day: 'Thu', posts: 6, engagement: 91, impressions: 22100 },
    { day: 'Fri', posts: 4, engagement: 73, impressions: 14600 },
    { day: 'Sat', posts: 2, engagement: 45, impressions: 8900 },
    { day: 'Sun', posts: 2, engagement: 38, impressions: 7200 }
  ];

  const maxEngagement = Math.max(...chartData?.map(d => d?.engagement));

  return (
    <div className="space-y-4">
      {/* Chart */}
      <div className="h-64 flex items-end justify-between gap-2 md:gap-4 px-2">
        {chartData?.map((data, index) => (
          <div key={index} className="flex-1 flex flex-col items-center gap-2">
            {/* Bar */}
            <div className="w-full flex flex-col items-center gap-1">
              <div className="relative w-full bg-muted rounded-t-lg overflow-hidden" style={{ height: '200px' }}>
                <div
                  className="absolute bottom-0 w-full bg-gradient-to-t from-primary to-primary/60 rounded-t-lg transition-all duration-500 hover:from-primary/90 hover:to-primary/50"
                  style={{ height: `${(data?.engagement / maxEngagement) * 100}%` }}
                >
                  <div className="absolute inset-0 flex items-center justify-center">
                    <span className="text-xs font-semibold text-white">
                      {data?.engagement}%
                    </span>
                  </div>
                </div>
              </div>
              {/* Posts indicator */}
              <div className="flex items-center gap-1">
                <Icon name="FileText" size={12} className="text-muted-foreground" />
                <span className="text-xs font-medium text-muted-foreground">{data?.posts}</span>
              </div>
            </div>
            {/* Day label */}
            <span className="text-xs font-medium text-foreground">{data?.day}</span>
          </div>
        ))}
      </div>

      {/* Legend */}
      <div className="flex flex-wrap items-center justify-center gap-4 pt-4 border-t border-border">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-primary"></div>
          <span className="text-xs text-muted-foreground">Engagement Rate</span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="FileText" size={14} className="text-muted-foreground" />
          <span className="text-xs text-muted-foreground">Posts Published</span>
        </div>
      </div>

      {/* Stats Summary */}
      <div className="grid grid-cols-3 gap-4 pt-4 border-t border-border">
        <div className="text-center">
          <p className="text-xs text-muted-foreground mb-1">Total Posts</p>
          <p className="text-lg font-bold text-foreground">
            {chartData?.reduce((sum, d) => sum + d?.posts, 0)}
          </p>
        </div>
        <div className="text-center">
          <p className="text-xs text-muted-foreground mb-1">Avg Engagement</p>
          <p className="text-lg font-bold text-foreground">
            {(chartData?.reduce((sum, d) => sum + d?.engagement, 0) / chartData?.length)?.toFixed(1)}%
          </p>
        </div>
        <div className="text-center">
          <p className="text-xs text-muted-foreground mb-1">Total Impressions</p>
          <p className="text-lg font-bold text-foreground">
            {(chartData?.reduce((sum, d) => sum + d?.impressions, 0) / 1000)?.toFixed(1)}k
          </p>
        </div>
      </div>
    </div>
  );
};

export default PerformanceChart;